export interface User {
  email: string,
  firstName: string,
  lastName: string,
  zipCode: string,
  phoneNumber: string,
  hasValidPaymentMethod: boolean,
  id: number,
  isAdmin: boolean,
  isEmployee: boolean,
  status: SubscriptionStatus,
  subscriptionId: number,
  plan: string,
  unsentGiveawaysCount: number,
  isSocialSignup: boolean,
  hasLessThan3Favs: boolean
}

export enum SubscriptionStatus {
  INACTIVE = 'inactive',
  ACTIVE = 'active',
  CANCELLED = 'cancelled',
  PAUSED = 'paused',
  SKIPPED = 'skipped',
  SUSPENDED = 'suspended',
  FORCED_SKIPPED = 'forced_skip',
  RETURNING = 'returning',
}

export interface SignupCredentials {
  email: string,
  password: string,
  turnstileToken?: string,
}
